<template>
  <div class="book-mall-page">
    <!-- 搜索框 -->
    <div class="search-wrapper">
      <div class="search-input-box" @click="goBookSearch">
        <img
          class="search-icon"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/search.png"
          alt="搜索"
        />
        <input class="search-placeholder" type="text" readonly placeholder="请输入图书名称" />
      </div>
    </div>

    <!-- 轮播广告位 -->
    <div class="book-mall-banner">
      <BannerVant />
    </div>

    <!-- 功能模块区：展示图固定，是否展示与跳转由 h5002 广告位下发 -->
    <div v-if="functionModuleWelfareAd || functionModuleSeckillAd" class="function-modules">
      <div
        v-if="functionModuleWelfareAd"
        class="new-user-welfare"
        :style="functionModuleBgStyle(functionModuleWelfareAd)"
        @click="goWelfare"
      ></div>
      <div
        v-if="functionModuleSeckillAd"
        class="seckill-course"
        :style="functionModuleBgStyle(functionModuleSeckillAd)"
        @click="goSeckill"
      ></div>
    </div>

    <!-- 热卖推荐 -->
    <div class="hot-sale-section" v-if="hotSaleList.length">
      <div class="hot-sale-header">
        <span class="section-title">热卖推荐</span>
        <div class="hot-tags">
          <div class="hot-tag-item">
            <img
              class="hot-icon"
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/hot.png"
              alt="热"
            />
          </div>
        </div>
      </div>

      <div class="hot-book-list">
        <div
          class="book-item"
          v-for="(item, index) in hotSaleList"
          :key="item.packageId || item.productId || index"
          @click="goHotSaleDetail(item)"
        >
          <div class="book-cover">
            <img :src="hotSaleCover(item)" alt="" />
            <span v-if="item.originalPrice" class="origin-text">¥{{ item.originalPrice }}</span>
          </div>
          <div class="book-price">
            <span
              class="courseType"
              v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >拼团价</span
            >
            <span v-else-if="item.promotionLabel" class="courseType">{{
              item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'
            }}</span>
            <span class="courseType" v-else>免费</span>
            <p class="showPic">
              <template
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >
                <b>¥</b>
                <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
              </template>
              <template v-else>
                <b>¥</b>
                <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                  item.sellPrice
                }}</span>
              </template>
            </p>
          </div>
          <div class="bookName">{{ item.productBookInfoVO.bookName || item.name }}</div>
        </div>
      </div>
    </div>

    <!-- 分类筛选 -->
    <div class="category-filter">
      <div class="filter-item" @click="openFilterModal">
        <span
          class="filter-text"
          :class="{ 'filter-text-active': filterState.examTypeIdList.length }"
          >考试类型</span
        >
        <img
          class="filter-arrow"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/down.png"
        />
      </div>
      <div class="filter-item" @click="openFilterModal">
        <span
          class="filter-text"
          :class="{ 'filter-text-active': filterState.subjectIdList.length }"
          >科目</span
        >
        <img
          class="filter-arrow"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/down.png"
        />
      </div>
      <div class="filter-item" @click="openFilterModal">
        <span
          class="filter-text"
          :class="{ 'filter-text-active': filterState.bookTypeIdList.length }"
          >图书分类</span
        >
        <img
          class="filter-arrow"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/down.png"
        />
      </div>
    </div>

    <!-- 图书卡片列表 -->
    <div class="book-card-list">
      <template v-if="bookList.length">
        <BookCard v-for="(item, k) in bookList" :key="k" :item="item" @click="goBookDetail" />
        <p v-if="bookMallLoadingMore" class="book-card-list-end">加载中...</p>
        <p v-else-if="bookMallListLoaded && !hasMoreBookMall" class="book-card-list-end">
          没有更多课程了！
        </p>
      </template>
      <EmptyData v-else-if="bookMallListLoaded" :emptyName="'noProductList'" />
    </div>

    <FilterModal
      v-if="showFilterModal"
      :initial-filter="filterState"
      @close="closeFilterModal"
      @confirm="onFilterConfirm"
    />
  </div>
</template>

<script>
import BookCard from './components/BookCard.vue';
import BannerVant from './components/Banner.vue';
import FilterModal from './components/FilterModal.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqBookMallList } from '@/api/bookMall';
import {
  BOOK_MALL_HOT_SALE_RECOMMEND_ID,
  BOOK_MALL_HOME_RECOMMEND_ID,
  BOOK_MALL_FUNCTION_MODULES_AD_CODE,
  BOOK_MALL_NEW_USER_WELFARE_AD_CONTENT_ID,
  BOOK_MALL_SECKILL_COURSE_AD_CONTENT_ID,
} from './constants/bookMallFilterOptions';
import { resetProductData, resetCoursePackage, handleJumpType, gioPlatform } from '@/utils/tools';
import { reqProductsNew, reqMajorAd, reqAdvertPlaying } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';

export default {
  name: 'BookMallPage',
  components: {
    BookCard, // 注册
    BannerVant,
    FilterModal,
    EmptyData,
  },
  data() {
    return {
      bookList: [],
      hotSaleList: [],
      /** 热卖推荐位 getHotSaleList 返回的 id、标题，用于埋点 adId_var / adName_var */
      hotSaleAdId: '',
      hotSaleAdName: '',
      showFilterModal: false,
      /** 筛选条件（无选中为空数组） */
      filterState: {
        examTypeIdList: [],
        subjectIdList: [],
        bookTypeIdList: [],
      },
      /** h5002 下发、id 为 1017/1018 的广告项，用于跳转 */
      functionModuleWelfareAd: null,
      functionModuleSeckillAd: null,
      /** 胶囊位广告位信息（h5002）用于埋点 adId_var / adName_var */
      functionModulesAdId: '',
      functionModulesAdName: '',
      functionModuleClickAt: null,
      /** 商城列表请求结束后才展示缺省，避免首屏闪一下 */
      bookMallListLoaded: false,
      /** 商城列表分页参数 */
      bookMallPageNum: 1,
      bookMallPageSize: 20,
      hasMoreBookMall: true,
      bookMallLoading: false,
      bookMallLoadingMore: false,
      /** getBookMall 返回的推荐位 id、标题，用于埋点 adId_var / adName_var */
      bookMallAdId: '',
      bookMallAdName: '',
    };
  },
  methods: {
    goBookSearch() {
      this.$router.push({ name: 'searchPage' });
    },
    goWelfare() {
      if (!this.functionModuleWelfareAd) return;
      if (this.functionModuleClickAt && Date.now() - this.functionModuleClickAt < 1000) return;
      this.functionModuleClickAt = Date.now();
      this.gioEvent('商城胶囊位', '', {
        adId: this.functionModulesAdId,
        adName: this.functionModulesAdName,
      });
      handleJumpType(this, this.functionModuleWelfareAd);
    },
    goSeckill() {
      if (!this.functionModuleSeckillAd) return;
      if (this.functionModuleClickAt && Date.now() - this.functionModuleClickAt < 1000) return;
      this.functionModuleClickAt = Date.now();
      this.gioEvent('商城胶囊位', '', {
        adId: this.functionModulesAdId,
        adName: this.functionModulesAdName,
      });
      handleJumpType(this, this.functionModuleSeckillAd);
    },
    async getFunctionModulesAd() {
      const code = BOOK_MALL_FUNCTION_MODULES_AD_CODE;
      try {
        const res = await reqAdvertPlaying([code]);
        const adInfo = res.data?.find((item) => item.adCode === code) || {};
        this.functionModulesAdId = adInfo.id != null ? String(adInfo.id) : '';
        this.functionModulesAdName = adInfo.title != null ? String(adInfo.title) : '';
        const list = adInfo.advertisingContentWebInfoRespVOS || [];
        let welfare = null;
        let seckill = null;
        list.forEach((ad) => {
          const aid = Number(ad.id);
          if (aid === BOOK_MALL_NEW_USER_WELFARE_AD_CONTENT_ID) welfare = ad;
          else if (aid === BOOK_MALL_SECKILL_COURSE_AD_CONTENT_ID) seckill = ad;
        });
        this.functionModuleWelfareAd = welfare;
        this.functionModuleSeckillAd = seckill;
      } catch (e) {
        this.functionModuleWelfareAd = null;
        this.functionModuleSeckillAd = null;
        this.functionModulesAdId = '';
        this.functionModulesAdName = '';
      }
    },
    functionModuleBgStyle(ad) {
      const imageUrl = Array.isArray(ad?.images) ? ad.images[0] : ad?.images;
      if (!imageUrl) return {};
      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '100%',
        backgroundSize: '100% 100%',
      };
    },
    gioEvent(adPosition_var, courseName_var, trackMeta = {}) {
      console.log({
        adPosition_var,
        courseName_var,
        adId_var: trackMeta.adId || this.bookMallAdId || '',
        adName_var: trackMeta.adName || this.bookMallAdName || '',
        platform_var: gioPlatform(),
      });
      gio('track', 'H5adClick_event', {
        adPosition_var,
        courseName_var,
        adId_var: trackMeta.adId || this.bookMallAdId || '',
        adName_var: trackMeta.adName || this.bookMallAdName || '',
        platform_var: gioPlatform(),
      });
    },
    openFilterModal() {
      this.showFilterModal = true;
    },
    closeFilterModal() {
      this.showFilterModal = false;
    },
    onFilterConfirm(payload) {
      this.filterState = {
        examTypeIdList: [...(payload.examTypeIdList || [])],
        subjectIdList: [...(payload.subjectIdList || [])],
        bookTypeIdList: [...(payload.bookTypeIdList || [])],
      };
      this.closeFilterModal();
      this.resetBookMallPagination();
      this.getBookMall();
    },
    hotSaleCover(item) {
      const bookCover = item.productBookInfoVO?.bookCover;
      if (bookCover) return bookCover;
      return item.coverMobile || '';
    },
    hotSaleOriginPrice(item) {
      if (item.promotionLabel && item.originalPrice != null) return item.originalPrice;
      return '';
    },
    goHotSaleDetail(item) {
      this.gioEvent('商城热卖推荐', '', {
        adId: this.hotSaleAdId,
        adName: this.hotSaleAdName,
      });
      this.openCourse(item);
    },
    openCourse(item) {
      sessionStorage.setItem('back', true);
      if (item.setType === 1) {
        this.$router.push({
          path: '/combinationCourse',
          query: { combinationId: item.packageId },
        });
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: { courseId: item.productId },
      });
    },
    async getHotSaleList() {
      const { code, data } = await reqMajorAd(BOOK_MALL_HOT_SALE_RECOMMEND_ID);
      if (code !== 0 || !data?.length) {
        this.hotSaleAdId = '';
        this.hotSaleAdName = '';
        return;
      }
      this.hotSaleAdId = data[0]?.id != null ? String(data[0].id) : '';
      this.hotSaleAdName = data[0]?.mainTitle != null ? String(data[0].mainTitle) : '';
      const { recommendContentVOList } = data[0];
      this.getMajorList(recommendContentVOList, 'hotSaleList');
    },
    // 进入图书详情
    goBookDetail(item) {
      this.gioEvent('商城课程列表', item.name);
      this.openCourse(item);
    },
    resetBookMallPagination() {
      this.bookMallPageNum = 1;
      this.hasMoreBookMall = true;
      this.bookList = [];
      this.bookMallListLoaded = false;
    },
    async getBookMall() {
      if (this.bookMallLoading) return;
      if (this.bookMallPageNum > 1 && !this.hasMoreBookMall) return;
      const { examTypeIdList, subjectIdList, bookTypeIdList } = this.filterState;
      const parmas = {
        baseBusinessLine: 1,
        homeRecommendId: BOOK_MALL_HOME_RECOMMEND_ID,
        examTypeIdList,
        subjectIdList,
        bookTypeIdList,
        pageNum: this.bookMallPageNum,
        pageSize: this.bookMallPageSize,
      };
      this.bookMallLoading = true;
      this.bookMallLoadingMore = this.bookMallPageNum > 1;
      try {
        const { code, data } = await reqBookMallList(parmas);
        if (code === 0) {
          const { recommendContentPageVO, id, mainTitle } = data || {};
          const list = recommendContentPageVO?.data || [];
          this.bookMallAdId = id != null ? String(id) : '';
          this.bookMallAdName = mainTitle != null ? String(mainTitle) : '';
          const pageNum = recommendContentPageVO?.pageNum || this.bookMallPageNum;
          const pages = recommendContentPageVO?.pages || 0;
          this.hasMoreBookMall = pageNum < pages;
          if (!list.length) {
            if (this.bookMallPageNum === 1) {
              this.bookList = [];
              this.bookMallListLoaded = true;
            }
            return;
          }
          this.getMajorList(list, 'bookList', this.bookMallPageNum > 1);
        } else {
          this.bookMallAdId = '';
          this.bookMallAdName = '';
          if (this.bookMallPageNum === 1) {
            this.bookList = [];
          }
          this.bookMallListLoaded = true;
        }
      } finally {
        this.bookMallLoading = false;
        this.bookMallLoadingMore = false;
      }
    },
    loadMoreBookMall() {
      if (this.bookMallLoading || !this.hasMoreBookMall) return;
      this.bookMallPageNum += 1;
      this.getBookMall();
    },
    handlePageScroll() {
      if (this.bookMallLoading || !this.hasMoreBookMall) return;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const clientHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight || clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 80) {
        this.loadMoreBookMall();
      }
    },
    getMajorList(recommendContentVOList, listKey = 'bookList', isAppend = false) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProductsNew(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || [], 2);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this[listKey] = isAppend ? [...this[listKey], ...allCourse] : allCourse;
        if (listKey === 'bookList') {
          this.bookMallListLoaded = true;
        }
      });
    },
  },
  mounted() {
    this.getBookMall();
    this.getHotSaleList();
    this.getFunctionModulesAd();
    window.addEventListener('scroll', this.handlePageScroll, { passive: true });
    localStorage.setItem('miniBeforePageName', 17);
    document.title = '图书商城';
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handlePageScroll);
  },
};
</script>

<style lang="scss" scoped>
.book-mall-page {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 750px;
  max-width: 100%;
  margin: 0 auto;
  padding: 22px 36px 0 36px;
  overflow: hidden;
  background: #f7f8fc;

  .search-wrapper {
    margin-bottom: 29px;
    .search-input-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      padding: 18px 442px 18px 24px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 40px;

      .search-icon {
        width: 22px;
        height: 22px;
        margin: 9px 0 7px 0;
      }

      .search-placeholder {
        padding-left: 10px;
        color: rgba(153, 153, 153, 1);
        font-size: 25px;
        line-height: 36px;
        white-space: nowrap;
      }
    }
  }

  .book-mall-banner {
    width: 678px;
    // height: 205px;
  }

  .function-modules {
    display: flex;
    justify-content: space-between;
    margin: 22px 0 0 0;

    .new-user-welfare {
      position: relative;
      width: 332px;
      height: 161px;
    }

    .seckill-course {
      position: relative;
      width: 332px;
      height: 161px;
    }
  }

  .hot-sale-section {
    margin: 22px 0 0 0;
    padding: 22px 29px 33px 29px;
    background: #fff;
    border: 2px solid #fff;
    border-radius: 14px;

    .hot-sale-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 22px;

      .section-title {
        margin-right: 9px;
        color: rgba(17, 17, 17, 1);
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
        white-space: nowrap;
      }

      .hot-tags {
        position: relative;
        display: flex;
        flex-direction: row;
        margin: 2px 0 5px 0;
        background: url(https://lanhu-oss-2537-2.lanhuapp.com/SketchPng93fda6fd70462cec15ae0f857dd6f2b7c31fbb9387fc03acdb36c4e3c6e04dbc)
          100% no-repeat;
        background-size: 100% 100%;

        .hot-tag-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 74px;
          height: 31px;

          .hot-icon {
            width: 96px;
            height: 34px;
          }

          .hot-text {
            margin-top: 9px;
            color: rgba(255, 87, 0, 1);
            font-size: 18px;
            line-height: 20px;
            white-space: nowrap;
          }
        }
      }
    }

    .hot-book-list {
      display: flex;
      flex-direction: row;
      gap: 14px;
      width: 100%; /* 移动端全屏宽度 */
      margin: 22px 0 0 0;

      /* ===== 横向滑动核心代码 ===== */
      overflow-x: auto; /* 开启横向滚动 */
      overflow-y: hidden; /* 禁止纵向滚动 */
      white-space: nowrap; /* 禁止换行 */
      scrollbar-width: none; /* 火狐隐藏滚动条 */
    }

    /* 隐藏滚动条（Chrome/Safari） */
    .hot-book-list::-webkit-scrollbar {
      display: none;
    }

    .book-item {
      /* 固定宽度，不让 flex 压缩 */
      flex-shrink: 0;
      width: 188px;
    }

    .book-cover {
      position: relative;
      margin-bottom: 9px;
      img {
        width: 188px;
        height: 250px;
        object-fit: cover; /* 图片不变形 */
        border-radius: 14px;
      }
      .origin-text {
        position: absolute;
        bottom: 7px;
        left: 7px;
        display: inline-block;
        width: 82px;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        line-height: 29px;
        text-align: center;
        background: rgba(31, 32, 46, 0.6);
        border-radius: 5px;
      }
    }
    .book-price {
      position: relative;
      width: 188px;
      font-size: 28px;
      background: #ffe7dd;
      border-radius: 7px;
      .courseType {
        display: inline-block;
        padding-left: 7px;
        color: #ff3b00;
        font-weight: 400;
        font-size: 18px;
        line-height: 29px;
      }
      .showPic {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 125px;
        height: 33px;
        color: hsl(0, 0%, 100%);
        font-weight: 500;
        font-size: 22px;
        line-height: 25px;
        line-height: 33px;
        text-align: center;
        background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/price-bg.png?v=2');
        background-size: 100%;
      }
    }
    .bookName {
      display: -webkit-box;
      margin-top: 22px;
      overflow: hidden;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 33px;
      white-space: normal;
      text-overflow: ellipsis;
      word-break: break-word;
      -webkit-line-clamp: 2; /* 控制行数：2行 */
      -webkit-box-orient: vertical;
    }
  }

  .category-filter {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 678px;
    margin: 22px 36px 0 5px;

    .filter-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 217px;
      padding: 22px 22px 22px 22px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 14px;

      .filter-text {
        color: rgba(153, 153, 153, 1);
        font-size: 25px;
        line-height: 36px;
        white-space: nowrap;
      }

      .filter-text-active {
        color: #ff7f41;
      }

      .filter-arrow {
        width: 40px;
        height: 40px;
      }
    }
  }

  .book-card-list {
    display: flex;
    flex-direction: column;
    gap: 22px;
    margin: 22px 0 0 0;

    .book-card-list-end {
      margin: 0 0 36px;
      padding: 0 36px;
      color: rgba(153, 153, 153, 1);
      font-size: 25px;
      line-height: 36px;
      text-align: center;
    }
  }
  ::v-deep .emptyIndent {
    height: fit-content !important;
    padding: 50px 0;
    .product {
      display: none;
    }
  }
}
</style>
